import { connect } from 'react-redux';
import UserMenu from 'components/UserMenu';
import { authLogout } from 'store/actionCreators/auth';

const mapDispatchToProps = {
  authLogout,
};

export default connect(
  undefined,
  mapDispatchToProps,
)(UserMenu);
